<template>
    <v-container fluid>
        <v-row>
           <h1>Test Telegram</h1>
        </v-row>
        <v-row>
            <VueScriptComponent script='<script async src="https://telegram.org/js/telegram-widget.js?10" data-telegram-login="TestSwtBot" data-size="medium" data-auth-url="https://swiset-admin.web.app/telegramauth" data-request-access="write"></script>'></VueScriptComponent>

        </v-row>
    </v-container>
</template>

<script>
    import VueScriptComponent from 'vue-script-component';
    export default {
        name: "TelegramTest",
        components: {
            VueScriptComponent,
        },
        methods: {
            onTelegramAuth(user) {
                console.log("Hereee");
                alert("Logged in as " + user.first_name + " " + user.last_name + " (" + user.id + (user.username ? ", @" + user.username : "") + ")");
                console.log(user);
            },
            telegramUser(user) {
                console.log(user);
            }
        }
    }
</script>

<style scoped>

</style>
